import React from 'react';
import { Box, Typography, CircularProgress, Chip, Fade } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import './nodeProgress.less';

// Mapping of technical node names to user-friendly labels
const nodeNameMapping = {
    intent_classifier: 'Understanding',
    disambiguate: 'Entities',
    proceed: 'Preparing',
    clarify: 'Clarifying',
    sql_agent: 'Data Fetch',
    narrative_agent: 'Narrative',
    visualization_agent: 'Visuals',
    combine_messages: 'Finalizing',
    knowledge_agent_flow: 'Knowledge Search',
    whitespace_agent: 'Whitespace Analysis',
    competition_identification: 'Competitors',
    bucket_size_identification: 'Market Segments',
    calculate_opportunity_size: 'Opportunity Size',
    visualization: 'Visualizing',
    narrative: 'Narrating',
    history_use_agent_flow: 'History',
    web_action_agent_flow: 'Browser Action',
};

const NodeProgress = ({ nodes }) => {
    // Only show relevant nodes if needed, or just all of them nicely
    // For now, we'll show executing and completed nodes in a nice row

    const getDisplayName = (name) => {
        return nodeNameMapping[name.toLowerCase()] || name.toUpperCase().replace(/_/g, ' ');
    };

    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, my: 1 }}>
            {nodes.map((node, index) => {
                const displayName = getDisplayName(node.node_name);
                const isExecuting = node.status === 'executing';
                const isCompleted = node.status === 'completed';

                return (
                    <Fade in={true} key={index} timeout={500}>
                        <Chip
                            icon={
                                isExecuting ? (
                                    <CircularProgress size={14} color="inherit" />
                                ) : isCompleted ? (
                                    <CheckCircleIcon style={{ fontSize: 16 }} />
                                ) : (
                                    <RadioButtonUncheckedIcon style={{ fontSize: 16 }} />
                                )
                            }
                            label={displayName}
                            size="small"
                            variant={isExecuting ? 'filled' : 'outlined'}
                            color={isExecuting ? 'primary' : isCompleted ? 'success' : 'default'}
                            sx={{
                                height: 24,
                                fontSize: '0.75rem',
                                fontWeight: isExecuting ? 600 : 400,
                                opacity: isCompleted ? 0.9 : 1,
                                borderColor: isCompleted ? 'success.main' : 'default',
                                transition: 'all 0.3s ease',
                            }}
                        />
                    </Fade>
                );
            })}
        </Box>
    );
};

export default NodeProgress;
